const changeBtn = () => {
    const Interval = setInterval(() => {
        const rebuyPrevBtn = document.querySelector(".splide__arrow--prev");
        const rebuyNextBtn = document.querySelector(".splide__arrow--next");
        if(rebuyPrevBtn && rebuyNextBtn) {
            // if(window.innerWidth < 750 && window.swymLandingURL.includes("/products/")) {
            //     rebuyPrevBtn.innerHTML = `
            //     <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style="transform: scale(1); margin-left: -20px;">
            //     <path d="M8.88672 2.1394L8.27969 1.53237C8.02266 1.27534 7.60703 1.27534 7.35273 1.53237L2.03711 6.84526C1.78008 7.10229 1.78008 7.51792 2.03711 7.77222L7.35273 13.0878C7.60977 13.3449 8.02539 13.3449 8.27969 13.0878L8.88672 12.4808C9.14648 12.221 9.14102 11.7972 8.87578 11.5429L5.58086 8.40386H13.4395C13.8031 8.40386 14.0957 8.11128 14.0957 7.74761V6.87261C14.0957 6.50894 13.8031 6.21636 13.4395 6.21636H5.58086L8.87578 3.07729C9.14375 2.823 9.14922 2.39917 8.88672 2.1394Z" fill="black"/>
            //     </svg>`;
            //     rebuyNextBtn.innerHTML = `
            //     <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" style="transform: scale(1); margin-left: 20px;">
            //     <path d="M6.11328 2.1394L6.72031 1.53237C6.97734 1.27534 7.39297 1.27534 7.64727 1.53237L12.9629 6.84526C13.2199 7.10229 13.2199 7.51792 12.9629 7.77222L7.64727 13.0878C7.39023 13.3449 6.97461 13.3449 6.72031 13.0878L6.11328 12.4808C5.85352 12.221 5.85898 11.7972 6.12422 11.5429L9.41914 8.40386H1.56055C1.19688 8.40386 0.904297 8.11128 0.904297 7.74761V6.87261C0.904297 6.50894 1.19688 6.21636 1.56055 6.21636H9.41914L6.12422 3.07729C5.85625 2.823 5.85078 2.39917 6.11328 2.1394Z" fill="black"/>
            //     </svg>`
            // }
            // else {
                rebuyPrevBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="97" height="64" viewBox="0 0 97 64" fill="none">
                    <g filter="url(#filter0_d_1990_2127)">
                        <rect x="75" y="38" width="56" height="20" rx="10" transform="rotate(-180 75 38)" fill="white"></rect>
                    </g>
                    <path d="M26.6464 27.6464C26.4512 27.8417 26.4512 28.1583 26.6464 28.3535L29.8284 31.5355C30.0237 31.7308 30.3403 31.7308 30.5355 31.5355C30.7308 31.3403 30.7308 31.0237 30.5355 30.8284L27.7071 28L30.5355 25.1716C30.7308 24.9763 30.7308 24.6597 30.5355 24.4645C30.3403 24.2692 30.0237 24.2692 29.8284 24.4645L26.6464 27.6464ZM67 27.5L27 27.5L27 28.5L67 28.5L67 27.5Z" fill="#333333"></path>
                    <defs>
                        <filter id="filter0_d_1990_2127" x="-3" y="0" width="100" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="4"></feOffset>
                        <feGaussianBlur stdDeviation="11"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1990_2127"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1990_2127" result="shape"></feBlend>
                        </filter>
                    </defs>
                </svg>`;
                rebuyNextBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="99" height="64" viewBox="0 0 99 64" fill="none">
                    <g filter="url(#filter0_d_1990_2130)">
                        <rect x="22" y="18" width="56" height="20" rx="10" fill="white"></rect>
                    </g>
                    <path d="M70.3536 28.3536C70.5488 28.1583 70.5488 27.8417 70.3536 27.6464L67.1716 24.4645C66.9763 24.2692 66.6597 24.2692 66.4645 24.4645C66.2692 24.6597 66.2692 24.9763 66.4645 25.1716L69.2929 28L66.4645 30.8284C66.2692 31.0237 66.2692 31.3403 66.4645 31.5355C66.6597 31.7308 66.9763 31.7308 67.1716 31.5355L70.3536 28.3536ZM30 28.5L70 28.5V27.5L30 27.5V28.5Z" fill="#333333"></path>
                    <defs>
                        <filter id="filter0_d_1990_2130" x="0" y="0" width="100" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="4"></feOffset>
                        <feGaussianBlur stdDeviation="11"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1990_2130"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1990_2130" result="shape"></feBlend>
                        </filter>
                    </defs>
                </svg>`;
            // }
            clearInterval(Interval)
        }
    }, 1000);
};

const changeAddBtn = () => {
    if(window.innerWidth < 750) {
        const rebuyAddDivs = document.querySelectorAll(".rebuy-product-actions");
        rebuyAddDivs.forEach(rebuyAddDiv => {
            rebuyAddBtn = rebuyAddDiv.querySelector("button");
            rebuyAddBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
            <path d="M0.399414 16.48C0.399414 7.64298 7.56241 0.47998 16.3994 0.47998C25.2364 0.47998 32.3994 7.64298 32.3994 16.48C32.3994 25.317 25.2364 32.48 16.3994 32.48C7.56241 32.48 0.399414 25.317 0.399414 16.48Z" fill="white"/>
            <path d="M22.1034 24.085H10.8334C10.5391 24.0883 10.2474 24.0307 9.97648 23.9157C9.70559 23.8008 9.46143 23.631 9.25938 23.417C8.85938 22.989 8.67338 22.417 8.74738 21.847L9.86038 13.46H23.0774L24.1774 21.847C24.3204 22.938 23.5114 23.934 22.3674 24.072L22.1034 24.085ZM19.2514 11.468C19.2514 10.001 18.0064 8.81201 16.4694 8.81201C14.9324 8.81201 13.6864 10.002 13.6864 11.468V13.46H19.2514V11.468Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.9706 18.3249H16.9356C16.9072 18.3249 16.88 18.3137 16.8599 18.2936C16.8399 18.2735 16.8286 18.2463 16.8286 18.2179V16.1819C16.8286 16.0682 16.7834 15.959 16.7029 15.8786C16.6225 15.7981 16.5134 15.7529 16.3996 15.7529C16.2858 15.7529 16.1767 15.7981 16.0962 15.8786C16.0158 15.959 15.9706 16.0682 15.9706 16.1819V18.2179C15.9706 18.2463 15.9593 18.2735 15.9392 18.2936C15.9192 18.3137 15.892 18.3249 15.8636 18.3249H13.8296C13.7716 18.3221 13.7136 18.3311 13.6592 18.3514C13.6047 18.3717 13.555 18.4028 13.5129 18.4428C13.4709 18.4829 13.4374 18.5311 13.4145 18.5845C13.3917 18.6379 13.3799 18.6953 13.3799 18.7534C13.3799 18.8115 13.3917 18.869 13.4145 18.9224C13.4374 18.9758 13.4709 19.0239 13.5129 19.064C13.555 19.1041 13.6047 19.1352 13.6592 19.1555C13.7136 19.1757 13.7716 19.1847 13.8296 19.1819H15.8646C15.893 19.1819 15.9202 19.1932 15.9403 19.2133C15.9603 19.2333 15.9716 19.2606 15.9716 19.2889V21.3249C15.9716 21.4387 16.0168 21.5478 16.0972 21.6283C16.1777 21.7087 16.2868 21.7539 16.4006 21.7539C16.5144 21.7539 16.6235 21.7087 16.7039 21.6283C16.7844 21.5478 16.8296 21.4387 16.8296 21.3249V19.2889C16.8296 19.2606 16.8409 19.2333 16.8609 19.2133C16.881 19.1932 16.9082 19.1819 16.9366 19.1819H18.9716C19.0296 19.1847 19.0876 19.1757 19.142 19.1555C19.1964 19.1352 19.2462 19.1041 19.2882 19.064C19.3303 19.0239 19.3638 18.9758 19.3866 18.9224C19.4095 18.869 19.4213 18.8115 19.4213 18.7534C19.4213 18.6953 19.4095 18.6379 19.3866 18.5845C19.3638 18.5311 19.3303 18.4829 19.2882 18.4428C19.2462 18.4028 19.1964 18.3717 19.142 18.3514C19.0876 18.3311 19.0296 18.3221 18.9716 18.3249H18.9706Z" fill="black"/>
            <mask id="mask0_6332_604" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="13" y="15" width="7" height="7">
            <path d="M18.9706 18.3249H16.9356C16.9072 18.3249 16.88 18.3137 16.8599 18.2936C16.8399 18.2735 16.8286 18.2463 16.8286 18.2179V16.1819C16.8286 16.0682 16.7834 15.959 16.7029 15.8786C16.6225 15.7981 16.5134 15.7529 16.3996 15.7529C16.2858 15.7529 16.1767 15.7981 16.0962 15.8786C16.0158 15.959 15.9706 16.0682 15.9706 16.1819V18.2179C15.9706 18.2463 15.9593 18.2735 15.9392 18.2936C15.9192 18.3137 15.892 18.3249 15.8636 18.3249H13.8296C13.7716 18.3221 13.7136 18.3311 13.6592 18.3514C13.6047 18.3717 13.555 18.4028 13.5129 18.4428C13.4709 18.4829 13.4374 18.5311 13.4145 18.5845C13.3917 18.6379 13.3799 18.6953 13.3799 18.7534C13.3799 18.8115 13.3917 18.869 13.4145 18.9224C13.4374 18.9758 13.4709 19.0239 13.5129 19.064C13.555 19.1041 13.6047 19.1352 13.6592 19.1555C13.7136 19.1757 13.7716 19.1847 13.8296 19.1819H15.8646C15.893 19.1819 15.9202 19.1932 15.9403 19.2133C15.9603 19.2333 15.9716 19.2606 15.9716 19.2889V21.3249C15.9716 21.4387 16.0168 21.5478 16.0972 21.6283C16.1777 21.7087 16.2868 21.7539 16.4006 21.7539C16.5144 21.7539 16.6235 21.7087 16.7039 21.6283C16.7844 21.5478 16.8296 21.4387 16.8296 21.3249V19.2889C16.8296 19.2606 16.8409 19.2333 16.8609 19.2133C16.881 19.1932 16.9082 19.1819 16.9366 19.1819H18.9716C19.0296 19.1847 19.0876 19.1757 19.142 19.1555C19.1964 19.1352 19.2462 19.1041 19.2882 19.064C19.3303 19.0239 19.3638 18.9758 19.3866 18.9224C19.4095 18.869 19.4213 18.8115 19.4213 18.7534C19.4213 18.6953 19.4095 18.6379 19.3866 18.5845C19.3638 18.5311 19.3303 18.4829 19.2882 18.4428C19.2462 18.4028 19.1964 18.3717 19.142 18.3514C19.0876 18.3311 19.0296 18.3221 18.9716 18.3249H18.9706Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_6332_604)">
            <path d="M16.3995 15.7528V14.0398V15.7538V15.7528ZM18.9705 16.6108H16.9355V20.0388H18.9705V16.6108ZM16.9355 16.6108C17.3615 16.6108 17.7705 16.7798 18.0715 17.0808L15.6475 19.5058C15.9885 19.8468 16.4525 20.0388 16.9355 20.0388V16.6108ZM18.0715 17.0808C18.3735 17.3828 18.5415 17.7908 18.5415 18.2178H15.1135C15.1135 18.7008 15.3055 19.1638 15.6475 19.5058L18.0715 17.0808ZM18.5415 18.2178V16.1818H15.1135V18.2178H18.5415ZM18.5415 16.1818C18.5415 15.6138 18.3165 15.0688 17.9145 14.6668L15.4905 17.0908C15.3711 16.9715 15.2763 16.8298 15.2116 16.6738C15.1469 16.5179 15.1136 16.3507 15.1135 16.1818H18.5415ZM17.9145 14.6668C17.5128 14.2649 16.9678 14.039 16.3995 14.0388V17.4678C16.0585 17.4678 15.7325 17.3318 15.4905 17.0908L17.9145 14.6668ZM16.3995 14.0388C15.8315 14.0388 15.2865 14.2648 14.8845 14.6668L17.3085 17.0908C17.1892 17.2103 17.0475 17.3051 16.8916 17.3698C16.7356 17.4345 16.5684 17.4678 16.3995 17.4678V14.0388ZM14.8845 14.6668C14.4826 15.0686 14.2567 15.6135 14.2565 16.1818H17.6855C17.6855 16.5228 17.5495 16.8488 17.3085 17.0908L14.8845 14.6668ZM14.2565 16.1818V18.2178H17.6855V16.1818H14.2565ZM14.2565 18.2178C14.2565 17.7908 14.4265 17.3828 14.7265 17.0808L17.1515 19.5058C17.4935 19.1638 17.6855 18.7008 17.6855 18.2178H14.2565ZM14.7265 17.0808C15.0285 16.7798 15.4375 16.6108 15.8635 16.6108V20.0388C16.3465 20.0388 16.8105 19.8468 17.1515 19.5058L14.7275 17.0798L14.7265 17.0808ZM15.8635 16.6108H13.8295V20.0388H15.8645V16.6108H15.8635ZM13.8285 16.6108C13.2595 16.6108 12.7145 16.8358 12.3125 17.2378L14.7375 19.6628C14.618 19.7822 14.4761 19.8768 14.32 19.9414C14.1638 20.0059 13.9965 20.039 13.8275 20.0388L13.8285 16.6108ZM12.3125 17.2378C11.911 17.6397 11.6855 18.1847 11.6855 18.7528H15.1135C15.1135 19.0938 14.9785 19.4218 14.7375 19.6628L12.3125 17.2378ZM11.6855 18.7528C11.6855 19.3218 11.9115 19.8668 12.3125 20.2688L14.7375 17.8438C14.9775 18.0848 15.1135 18.4108 15.1135 18.7528H11.6855ZM12.3125 20.2688C12.7145 20.6698 13.2595 20.8958 13.8285 20.8958V17.4678C14.1685 17.4678 14.4965 17.6028 14.7375 17.8438L12.3125 20.2688ZM13.8285 20.8958H15.8635V17.4678H13.8295V20.8958H13.8285ZM15.8635 20.8958C15.4375 20.8958 15.0285 20.7268 14.7275 20.4258L17.1515 18.0008C16.9824 17.8317 16.7816 17.6977 16.5606 17.6062C16.3396 17.5147 16.1027 17.4677 15.8635 17.4678V20.8958ZM14.7275 20.4258C14.5784 20.2765 14.4601 20.0992 14.3794 19.9041C14.2988 19.709 14.2574 19.4999 14.2575 19.2888H17.6855C17.6855 18.8058 17.4935 18.3428 17.1515 18.0008L14.7275 20.4258ZM14.2575 19.2888V21.3248H17.6855V19.2888H14.2575ZM14.2575 21.3248C14.2575 21.8928 14.4825 22.4378 14.8845 22.8398L17.3085 20.4158C17.5495 20.6558 17.6855 20.9838 17.6855 21.3248H14.2575ZM14.8845 22.8398C15.2865 23.2418 15.8315 23.4678 16.3995 23.4678V20.0388C16.7405 20.0388 17.0665 20.1748 17.3085 20.4158L14.8845 22.8398ZM16.3995 23.4678C16.9675 23.4678 17.5125 23.2418 17.9145 22.8398L15.4905 20.4158C15.7315 20.1748 16.0585 20.0388 16.3995 20.0388V23.4678ZM17.9145 22.8398C18.3165 22.4378 18.5425 21.8928 18.5425 21.3248H15.1135C15.1135 20.9838 15.2495 20.6568 15.4905 20.4148L17.9145 22.8398ZM18.5425 21.3248V19.2888H15.1135V21.3248H18.5425ZM18.5425 19.2888C18.5425 19.7148 18.3725 20.1238 18.0725 20.4258L15.6475 18.0008C15.4783 18.1699 15.344 18.3707 15.2524 18.5917C15.1608 18.8127 15.1136 19.0496 15.1135 19.2888H18.5425ZM18.0725 20.4258C17.7705 20.7268 17.3615 20.8958 16.9355 20.8958V17.4678C16.4525 17.4678 15.9885 17.6598 15.6475 18.0008L18.0725 20.4258ZM16.9355 20.8958H18.9705V17.4678H16.9355V20.8958ZM18.9705 20.8958C19.5395 20.8958 20.0845 20.6698 20.4865 20.2688L18.0615 17.8438C18.3025 17.6038 18.6295 17.4678 18.9715 17.4678V20.8958H18.9705ZM20.4865 20.2688C20.8875 19.8668 21.1135 19.3218 21.1135 18.7528H17.6855C17.6855 18.4128 17.8205 18.0848 18.0615 17.8438L20.4865 20.2688ZM21.1135 18.7528C21.1135 18.1848 20.8875 17.6398 20.4865 17.2378L18.0615 19.6628C17.9422 19.5433 17.8475 19.4014 17.783 19.2452C17.7185 19.0891 17.6854 18.9218 17.6855 18.7528H21.1135ZM20.4865 17.2378C20.2874 17.0389 20.051 16.8811 19.7909 16.7735C19.5308 16.6659 19.252 16.6106 18.9705 16.6108V20.0388C18.6305 20.0388 18.3025 19.9038 18.0615 19.6628L20.4865 17.2378Z" fill="black"/>
            </g>
            </svg>`
            rebuyAddBtn.style.backgroundColor = "transparent";
            rebuyAddBtn.closest(".rebuy-product-actions").style.marginTop = 0;
        })
    }
}

document.addEventListener('click', (e) => {
    const cartBtn = e.target.closest("a.header__icon--cart");
    if(cartBtn) {
        setTimeout(() => {
            const rebuyFullDiv = document.querySelector(".drawer__cart-items-recommendation");
            if(rebuyFullDiv) {
                const rebuyA = rebuyFullDiv.querySelector("a.rebuy-product-title");
                rebuyA.removeAttribute("aria-label");
                rebuyA.removeAttribute("aria-level");
                rebuyA.removeAttribute("role");
                const rebuyDiv = rebuyFullDiv.querySelector("div.rebuy-product-grid");
                rebuyDiv.setAttribute("aria-label", "Rebuy Product");
            }
        }, 2000);
    }
})

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        changeBtn();
        changeAddBtn();
    }, 5000);
    if(window.innerWidth < 750) {
        const bell = document.querySelector('.wisepops-shopify');
        const target = document.querySelector('.header__icon--notification');
        if (bell && target) {
            target.prepend(bell);
        }
    }
    const makeBtn = setInterval(() => {
        const rebuyDiv = document.querySelector("#rebuy-widget-231077")?.querySelector(".rebuy-widget-content");
        const shopAllBtn = document.createElement("a");
        shopAllBtn.href = "/collections/new-arrivals";
        shopAllBtn.className = "button white arrow-m";
        shopAllBtn.style.width = "fit-content";
        shopAllBtn.style.gap = "10px";
        if(Shopify.locale == "de") {
            shopAllBtn.textContent = "Alles anzeigen";
            shopAllBtn.href = "/de-de/collections/neuheiten";
        }
        else if(Shopify.locale == "es" && Shopify.country == "ES") {
            shopAllBtn.textContent = "Ver todo";
            shopAllBtn.href = "/es-es/collections/novedades";
        }
        else if(Shopify.locale == "it" && Shopify.country == "IT") {
            shopAllBtn.textContent = "Visualizza tutto";
            shopAllBtn.href = "/it-it/collections/nuovi-arrivi";
        }
        else if(Shopify.locale == "fr" && Shopify.country == "FR") {
            shopAllBtn.textContent = "Tout afficher";
            shopAllBtn.href = "/fr-fr/collections/nouveautes";
        }
        else if(Shopify.locale == "fr" && Shopify.country == "BE") {
            shopAllBtn.textContent = "Tout afficher";
            shopAllBtn.href = "/fr-be/collections/nouveautes";
        }
        else if(Shopify.locale == "nl" && Shopify.country == "BE") {
            shopAllBtn.textContent = "Alles bekijken";
            shopAllBtn.href = "/nl-be/collections/nieuwe-collectie";
        }
        else if(Shopify.locale == "nl" && Shopify.country == "NL") {
            shopAllBtn.textContent = "Alles bekijken";
            shopAllBtn.href = "/nl-nl/collections/nieuwe-collectie";
        }
        else {
            shopAllBtn.textContent = "Shop All";
        }
        if(rebuyDiv) {
            rebuyDiv.appendChild(shopAllBtn);
            clearInterval(makeBtn)
        }
    }, 1000);
    setTimeout(() => {
        clearInterval(makeBtn)
    }, 10000);
    const rebuyADA = setInterval(() => {
        const rebuyFullDivs = document.querySelectorAll(".rebuy-widget");
        if(rebuyFullDivs.length != 0) {
            rebuyFullDivs.forEach(rebuyFullDiv => {
                const rebuyAs = rebuyFullDiv.querySelector("div.splide__list")?.querySelectorAll("a.rebuy-product-title");
                if(rebuyAs && rebuyAs.length != 0) {
                    rebuyAs.forEach(atag => {
                        atag.removeAttribute("aria-label");
                        atag.removeAttribute("aria-level");
                        atag.removeAttribute("role");
                    })
                }
                const rebuyDivs = rebuyFullDiv.querySelectorAll("div.rebuy-product-block");
                setTimeout(() => {
                    if(rebuyDivs.length != 0) {
                        rebuyDivs.forEach(div => {
                            div.removeAttribute("aria-hidden");
                        })
                    }
                }, 1000);
                if (rebuyFullDiv.querySelector("h4.primary-title")) {
                    rebuyFullDiv.querySelector("h4.primary-title").setAttribute("role", "heading");
                    rebuyFullDiv.querySelector("h4.primary-title").setAttribute("aria-level", 2);
                }
                rebuyFullDiv.parentElement.parentElement.parentElement.style.padding = 0;
            })
            clearInterval(rebuyADA);
        }
    }, 1000);
    const articleMain = document.querySelector("article.article-template");
    if(articleMain) {
        articleMain.parentElement.parentElement.style.backgroundColor = "#fafafa";
        articleMain.querySelector(".article-template__link").querySelector("span").innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="9" viewBox="0 0 19 9" fill="none">
        <path d="M0.633143 4.22827C0.44208 4.42764 0.448818 4.74415 0.648193 4.93522L3.89718 8.04875C4.09656 8.23981 4.41307 8.23307 4.60413 8.0337C4.79519 7.83432 4.78845 7.51781 4.58908 7.32675L1.70109 4.55917L4.46867 1.67118C4.65973 1.4718 4.65299 1.15529 4.45362 0.96423C4.25425 0.773168 3.93773 0.779907 3.74667 0.979281L0.633143 4.22827ZM18.9943 4.191L18.9836 3.69111L0.983498 4.07433L0.994141 4.57422L1.00478 5.0741L19.0049 4.69088L18.9943 4.191Z" fill="black"/>
        </svg>`;
    }
    const accountMain = document.querySelector("div.swiper-container.tabs-buttons.swiper-initialized.swiper-vertical.swiper-free-mode.swiper-watch-progress.swiper-backface-hidden.swiper-thumbs");
    if(accountMain) {
        accountMain.parentElement.parentElement.style.paddingTop = "60px";
        const header = document.createElement("h1");
        header.textContent = "ADA";
        header.style.position = "absolute";
        header.style.width = "1px";
        header.style.height = "1px";
        header.style.padding = "0";
        header.style.margin = "-1px";
        header.style.overflow = "hidden";
        header.style.clip = "rect(0, 0, 0, 0)";
        header.style.whiteSpace = "nowrap";
        header.style.border = "0";
        document.body.querySelector("main").prepend(header);
        document.querySelector('input[type="checkbox"][name="address[default]"]').setAttribute("aria-label", "default address");
    }
})

window.addEventListener('resize', () => {
    changeBtn();
    changeAddBtn();
})

// -----------------   ADA ----------------------------

document.addEventListener("DOMContentLoaded", () => {
    const setVideoAlt = setInterval(() => { 
        const videoImg = document.querySelector(".color-background-1 .video-section .auto-video img");
        if (videoImg) {
            videoImg.setAttribute("alt", "Video Preview");
            clearInterval(setVideoAlt)
        }
    }, 1000);

    const removeAria = setInterval(() => {
        const ariaBtns = document.querySelectorAll("button.thumbnail.global-media-settings");
        if(ariaBtns.length != 0) {
            ariaBtns.forEach(btn => {
                btn.removeAttribute("aria-label");
                btn.removeAttribute("aria-controls");
                btn.removeAttribute("aria-describedby");
            });
            clearInterval(removeAria);
        }
    }, 1000);

    const announcement = setInterval(() => {
        const announceDiv = document.querySelector("div.announcement-bar__announcement");
        if(announceDiv) {
            announceDiv.setAttribute("aria-label", "Announcement1");
            clearInterval(announcement);
        }
    })

    setTimeout(() => {
        const stockist = document.querySelector("div.stockist-map.stockist-map-google");
        if(stockist) {
            stockist.removeAttribute("aria-label");
            const header = document.createElement("h1");
            header.textContent = "ADA";
            header.style.position = "absolute";
            header.style.width = "1px";
            header.style.height = "1px";
            header.style.padding = "0";
            header.style.margin = "-1px";
            header.style.overflow = "hidden";
            header.style.clip = "rect(0, 0, 0, 0)";
            header.style.whiteSpace = "nowrap";
            header.style.border = "0";
            document.body.querySelector("main").prepend(header);
        }

        const searchInput = document.querySelectorAll(".search__input.field__input.fast-autocomplete.fast-autocomplete-input");
        if (searchInput[0]) {
            searchInput[0].removeAttribute("aria-labelledby");
        }
        if (searchInput[1]) {
            searchInput[1].removeAttribute("aria-labelledby");
        }
        if (searchInput[2]) {
            searchInput[2].removeAttribute("aria-labelledby");
        }

        const searchForm = document.querySelectorAll('.search.search-modal__form.fast-simon-form');
        searchForm.forEach(element => {
            element.setAttribute("action", "/pages/search-results");
        });
    }, 5000);
});

const bell = setInterval(() => {
    const accountIcon = document.querySelector("header a.header__icon--account");
    const bellIcon = document.querySelector("header div.shopify-block.shopify-app-block");

    if (accountIcon && bellIcon && accountIcon.parentNode) {
        accountIcon.parentNode.insertBefore(bellIcon, accountIcon);
        bellIcon.classList.add("small-hide");
        clearInterval(bell);
    }
}, 100);

const fixformada = setInterval(() => {
    const div = document.querySelector("div.globo-formbuilder");
    const heading = div?.querySelector("h3.globo-heading");
    heading?.setAttribute("role", "heading");
    heading?.setAttribute("aria-level", "2");
}, 500);

const fixatagada = setInterval(() => {
    const atag = document.querySelector("a[data-acsb-sr-only='true']");
    const div = document.querySelector("div#shop-hcaptcha-badge-container");
    atag?.setAttribute("role", "main");
    div?.setAttribute("role", "main");
})

setTimeout(() => {
    clearInterval(fixformada);
    clearInterval(fixatagada);
}, 10000);

document.addEventListener("rebuy:cart.change", function(event) {
  const cart = event.detail.cart;
  const cartBubble = document.querySelector(".cart-count-bubble span");
  remove_title();
  if (cartBubble) {
    cartBubble.textContent = cart.cart.item_count;
  }
});

const remove_title = () => {
    const rebuywidget = setInterval(() => {
        const rebuyheaders = document.querySelectorAll("h4.primary-title");
        const rebuyproducts = document.querySelectorAll("h5.rebuy-product-title");
        const rebuycartTitles = document.querySelectorAll("a.rebuy-cart__flyout-item-product-title");
        const cartTitles = document.querySelectorAll("a.cart-item__name");

        if (rebuyheaders.length > 0) {
            rebuyheaders.forEach(rebuyheader => {
                rebuyheader.setAttribute("role", "heading");
                rebuyheader.setAttribute("aria-level", "2");
            });
        }

        if (rebuyproducts.length > 0) {
            rebuyproducts.forEach(rebuyproduct => {
                rebuyproduct.setAttribute("role", "heading");
                rebuyproduct.setAttribute("aria-level", "2");
                const rebuytitle = rebuyproduct.querySelector("a");
                const productTitle = rebuytitle.textContent;
                const parts = productTitle.split("|");
                rebuytitle.textContent = parts[0].trim();
            });
        }

        if (rebuycartTitles.length > 0) {
            rebuycartTitles.forEach(rebuycartTitle => { 
                const productTitle = rebuycartTitle.textContent;
                const parts = productTitle.split("|");
                rebuycartTitle.textContent = parts[0].trim();
            });
        }

        if (cartTitles.length > 0) {
            cartTitles.forEach(cartTitle => { 
                const title = cartTitle.textContent;
                const parts = title.split("|");
                cartTitle.textContent = parts[0].trim();
            });
        }
    }, 100);

    setTimeout(() => {
        clearInterval(rebuywidget);
    }, 15000);
}